import { classNames } from "@/shared/utils/classnames";
import { ReactNode } from "react";

export type ColumnText = {
  title: ReactNode;
  color?: string;
  className?: string;
  wrap?: boolean;
};

const ColumnText: React.FC<ColumnText> = ({
  title,
  color,
  className,
  wrap,
}) => {
  const textColorClass = color ? `text-${color}-600` : "text-gray-500";

  return (
    <td
      className={classNames(
        `${!wrap ? "whitespace-nowrap" : ""} px-3 py-5 text-sm ${textColorClass}`,
        className
      )}
    >
      {title}
    </td>
  );
};

export default ColumnText;
